import { registerCrudStore } from '@/libs/core/crud/register-crud-store';
import { StateOfCapitalModel, StateOfCapitalYearModel } from '@/libs/Api';
import { StoreName } from '@/libs/core/store/store-name';
import { StateOfCapitalDataService } from '../state-of-capital-data-service';
import { StateOfCapitalYearDataService } from '../state-of-capital-year-data-service';

export const stateOfCapitalStore = registerCrudStore<StateOfCapitalModel, StateOfCapitalModel>(StoreName.StateOfCapital, new StateOfCapitalDataService());
export const stateOfCapitalYearStore = registerCrudStore<StateOfCapitalYearModel, StateOfCapitalYearModel>(StoreName.StateOfCapitalYear, new StateOfCapitalYearDataService());